import React, { useState, useEffect, useContext } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { Redirect } from "react-router-dom";

import {
  Card,
  Row,
  CardBody,
  Col,
  FormGroup,
  Label,
  Button,
  Alert,
  CardTitle,
  FormText,
} from "reactstrap";
import { getCookie } from "../../jwt/_helpers/cookie";
import { useFetch } from "../../utils/fetchHook";
import { StateContext } from "../../utils/context";
import TableHelper from "../../components/tableHelper";
import AsyncDropdownNormal from "../../components/asyncDropdownNormal";
import { useTranslation } from "react-i18next";

const API_URL = process.env.REACT_APP_API_URL_BASE;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;

const MusicLinkUrlpartAdd = ({ match }) => {
  const token = getCookie("token");
  const { t } = useTranslation();
  const options = {
    method: "GET",
    mode: 'cors',
    headers: {
      Authorization: `Bearer ${token}`,
      "x-api-key": X_API_KEY,
      "Content-Type": "application/json"
    }
  };

  const Schema = Yup.object().shape({
    part: Yup.string()
      .required(t("musicLinkUrlParts.add.form.validation.part.required"))
      .max(16, t("musicLinkUrlParts.add.form.validation.part.max")),
  });

  const {currentUser} = useContext(StateContext);
  const currentID = match.url.split("/")[2] === "add" ? null : match.url.split("/")[2];
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [errorDupl, setErrorDupl] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [loadedAll, setLoadedAll] = useState(() => (currentID ? false : true));

  const [parentUserOnly, setParentUserOnly] = useState('');
  const [subUser, setSubUser] = useState('');
  const [subUserId, setSubUserId] = useState(null);
  const [subUserEndpoint, setSubUserEndpoint] = useState('');
  const [subUserUrlPartAllowance, setSubUserUrlPartAllowance] = useState(0);

  const [urlpartData, loadingurlpartData] = useFetch(
    "GET",
    `musiclinks_urlparts/${currentID}/`,
    token
  );

  const axiosOptions = {
    method: "POST",
    mode: "cors",
    headers: {
      Authorization: `Bearer ${token}`,
      "x-api-key": X_API_KEY,
      "Content-Type": "application/json",
    },
  };

  useEffect(() => {
    if (Array.isArray(urlpartData) && urlpartData.length === 0) {
      return;
    }
    setLoadedAll(true);
  }, [urlpartData]);

  const onSubmit = async (payload, { setStatus, setSubmitting }) => {
    setStatus();
    setErrorDupl(false);

    if (subUserId) {
      payload.sub_user_id = subUserId;
    }

    let result = null;
    try {
      if (currentID) {
        await axios({
          url: `${API_URL}musiclinks_urlparts/${currentID}/`,
          data: payload,
          ...axiosOptions,
          method: "PUT",
        });
        setRedirect(true);
      } else {
        const isExist = await axios.get(
          `${API_URL}musiclinks_urlparts/?search=${payload.part}`,
          axiosOptions
        );
        if (isExist.status === 200) {
          if (isExist.data.count) {
            setErrorDupl(true);
          } else {
            await axios({
              url: `${API_URL}musiclinks_urlparts/`,
              data: payload,
              ...axiosOptions,
            });
            setRedirect(true);
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      {loadedAll === false ? (
        <TableHelper loading />
      ) : (
        <Row>
          <Col sm={12}>
            <Card>
              <CardBody>
                <CardTitle tag="h4">
                  {currentID ? t("musicLinkUrlParts.add.form.label.editUrlPart") : t("musicLinkUrlParts.add.form.label.addUrlPart")}
                </CardTitle>

                <Formik
                  initialValues={{
                    part: urlpartData.part || "",
                  }}
                  validationSchema={Schema}
                  onSubmit={onSubmit}
                  render={({
                    errors,
                    status,
                    touched,
                    isSubmitting,
                    setFieldValue,
                    setFieldTouched,
                    values,
                    ...rest
                  }) => {
                    return (
                      <Form className="mt-3">

                      { (!currentID && currentUser.is_premium_user)  &&
                        <FormGroup className="select-search-wrap" row>
                          <Label
                            sm={2}
                          >
                            {t("musicLinkUrlParts.add.form.label.subUser")}
                          </Label>  
                          <Col>
                            {
                              subUser ?
                                <div className="releaseFileRow">
                                    <p className="releaseFileRowName"> {subUser}</p>
                                    <Button className="btn btn-outline-info"
                                      onClick={() => {
                                        setSubUser('');
                                        setSubUserId(null);
                                        setSubUserEndpoint('');
                                        setParentUserOnly('');
                                        setSubUserUrlPartAllowance(0);
                                      }}
                                    >
                                      {t("musicLinkUrlParts.add.form.button.reset")}
                                    </Button>
                                </div>
                                :
                              <AsyncDropdownNormal
                                fetchOptions={options}
                                endpoint={`sub-users`}
                                subUserEndpoint={subUserEndpoint}
                                parentUserOnly={parentUserOnly}
                                labelField="username"
                                extraFields={["music_link_urlparts_allowance", "music_link"]}
                                onChange={e => {
                                  let subUserId = e.value;
                                  let username = e.label;
                                  let urlPartAllowance = e.music_link_urlparts_allowance;

                                  if(subUserId !== '') {
                                    setSubUser(username);
                                    setSubUserId(subUserId);
                                    setSubUserEndpoint(`sub-user/${subUserId}/`);
                                    setParentUserOnly('');
                                    setSubUserUrlPartAllowance(urlPartAllowance);
                                  } else {
                                    setSubUser('');
                                    setSubUserId(null);
                                    setSubUserEndpoint('');
                                    setParentUserOnly('');
                                    setSubUserUrlPartAllowance(0);
                                  }
                                }}
                                placeholder={t("musicLinkUrlParts.add.form.placeholder.subUser")}
                              />
                            }
                          <FormText color="muted">
                            {t("musicLinkUrlParts.add.form.help_text.subUser")}
                          </FormText>
                          {(subUser && subUserUrlPartAllowance<=0) && (
                            <p
                              style={{
                                fontSize: "12px",
                                color: "red",
                                margin: "2px 0 0 0",
                              }}
                            >
                              {t("musicLinkUrlParts.add.form.message.subUserLimit")}
                            </p>
                          )}
                          </Col>
                        </FormGroup>
                      }

                        <FormGroup row>
                          <Label for="part" sm={2}>
                            {t("musicLinkUrlParts.add.form.label.part")}
                          </Label>
                          <Col>
                            <Field
                              name="part"
                              type="text"
                              className={
                                "form-control" +
                                (errors.part && touched.part
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="part"
                              component="div"
                              className="invalid-feedback"
                            />
                            {errorDupl && (
                              <p
                                style={{
                                  fontSize: "12px",
                                  color: "red",
                                  margin: "2px 0 0 0",
                                }}
                              >
                                {t("musicLinkUrlParts.add.form.message.urlPartAlreadyTaken")}
                              </p>
                            )}
                          </Col>
                        </FormGroup>

                        <FormGroup row>
                          <Col>
                            <Button color="success" disabled={subUser && subUserUrlPartAllowance<=0}>{t("musicLinkUrlParts.add.form.button.submit")}</Button>
                          </Col>
                        </FormGroup>
                      </Form>
                    );
                  }}
                />
                {success && (
                  <Alert color="success">
                    {currentID ? t("musicLinkUrlParts.add.message.updateSuccess") : t("musicLinkUrlParts.add.message.addSuccess")}
                  </Alert>
                )}
                {redirect ? <Redirect to="/music-link-urlpart" /> : null}
                {error && (
                  <Alert color="danger">
                    {t("musicLinkUrlParts.add.message.error")}
                  </Alert>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default MusicLinkUrlpartAdd;
